module.exports = __webpack_public_path__ + "static/media/cowie.ee7be403.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cowie.jpg
// module id = 200
// module chunks = 0